/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadedFile } from './UploadedFile';
import {
    UploadedFileFromJSON,
    UploadedFileFromJSONTyped,
    UploadedFileToJSON,
    UploadedFileToJSONTyped,
} from './UploadedFile';

/**
 * 
 * @export
 * @interface UploadBatchFinalizeRequest
 */
export interface UploadBatchFinalizeRequest {
    /**
     * 
     */
    batchId: string;
    /**
     * 
     */
    uploaded: Array<UploadedFile>;
}

/**
 * Check if a given object implements the UploadBatchFinalizeRequest interface.
 */
export function instanceOfUploadBatchFinalizeRequest(value: object): value is UploadBatchFinalizeRequest {
    if ((!('batchId' in (value as Record<string, any>)) && !('batch_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['batchId'] === undefined && (value as Record<string, any>)['batch_id'] === undefined)) return false;
    if (!('uploaded' in value) || value['uploaded'] === undefined) return false;
    return true;
}

export function UploadBatchFinalizeRequestFromJSON(json: any): UploadBatchFinalizeRequest {
    return UploadBatchFinalizeRequestFromJSONTyped(json, false);
}

export function UploadBatchFinalizeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchFinalizeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'batchId': json['batch_id'],
        'uploaded': ((json['uploaded'] as Array<any>).map(UploadedFileFromJSON)),
    };
}

export function UploadBatchFinalizeRequestToJSON(json: any): UploadBatchFinalizeRequest {
    return UploadBatchFinalizeRequestToJSONTyped(json, false);
}

export function UploadBatchFinalizeRequestToJSONTyped(value?: UploadBatchFinalizeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch_id': value['batchId'],
        'uploaded': ((value['uploaded'] as Array<any>).map(UploadedFileToJSON)),
    };
}

